import { useTranslation } from 'react-i18next';

export const useErrorMessages = () => {
  const { t } = useTranslation('errors');

  return {
    default: t('default'),
    networkError: t('networkError'),
    unauthorized: t('unauthorized'),
    notFound: t('notFound'),
    serverError: t('serverError'),
    timeout: t('timeout'),
    unknownError: t('unknownError')
  };
};
